import { B as v, a as g } from "./chunk-BaseElement-BuXbltG-.js";
import { W as b } from "./chunk-WithShopifyCart-CoFAHix4.js";
import { x as m, E as C } from "./chunk-lit-element-CNHURX5C.js";
import { t as d } from "./chunk-custom-element-ttkHUa8w.js";
import { r as _ } from "./chunk-state-DXVUuFZf.js";
import { o as w } from "./chunk-query-assigned-elements-DAuAKBi3.js";
import { e as P, n as y } from "./chunk-ref-BxW0RSF3.js";
import "./chunk-quantity-input-ChjjQqAA.js";
import { H as O } from "./chunk-HTMLUpdateUtility-pt0dDGgp.js";
import { n as p } from "./chunk-property-Baio2yOX.js";
var U = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, u = (e, t, a, i) => {
  for (var r = i > 1 ? void 0 : i ? $(t, a) : t, o = e.length - 1, s; o >= 0; o--)
    (s = e[o]) && (r = (i ? s(t, a, r) : s(r)) || r);
  return i && r && U(t, a, r), r;
};
let c = class extends b(v) {
  constructor() {
    super(...arguments), this.error = null, this.$errorMessage = P();
  }
  async _handleFormSubmit(e) {
    e.preventDefault(), await this.submitForm();
  }
  async submitForm() {
    var e;
    try {
      this.error = null;
      const t = this.productForm;
      t && (await this.addItemToWithForm(new FormData(t)), this.openCartDrawer());
    } catch (t) {
      this.error = t.errors || t.message || "An error occurred", await this.updateComplete, (e = this.$errorMessage.value) == null || e.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }
  get errorHTML() {
    return this.error ? m`<p
        class="body bg-brand-error/5 text-brand-error mt-4 rounded-xs p-4 text-sm"
        ${y(this.$errorMessage)}
      >
        ${this.error}
      </p>` : C;
  }
  get productForm() {
    return Array.from(this.assignedElements).find(
      (e) => e.tagName === "FORM"
    );
  }
  render() {
    return m`
      <slot @submit=${this._handleFormSubmit}></slot>
      ${this.errorHTML}
    `;
  }
};
u([
  _()
], c.prototype, "error", 2);
u([
  w()
], c.prototype, "assignedElements", 2);
c = u([
  d("product-form")
], c);
var E = Object.defineProperty, V = Object.getOwnPropertyDescriptor, S = (e, t, a, i) => {
  for (var r = i > 1 ? void 0 : i ? V(t, a) : t, o = e.length - 1, s; o >= 0; o--)
    (s = e[o]) && (r = (i ? s(t, a, r) : s(r)) || r);
  return i && r && E(t, a, r), r;
};
const h = "variant-picker:change";
let f = class extends g {
  connectedCallback() {
    super.connectedCallback(), this._handleOptionChange = this._handleOptionChange.bind(this), this.addEventListener("change", this._handleOptionChange);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("change", this._handleOptionChange);
  }
  _handleOptionChange(e) {
    e.stopPropagation();
    const t = e.target, a = t.tagName === "SELECT" ? t.selectedOptions[0] : t;
    t && this.$emit(h, {
      event: e,
      target: a,
      variantId: a.dataset.variantId,
      productUrl: a.dataset.productUrl,
      selectedOptionValues: this.selectedOptionValues
    });
  }
  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll(
        "select, fieldset input:checked"
      )
    ).map(({ dataset: e }) => e.optionValueId).filter(Boolean);
  }
};
f = S([
  d("variant-picker")
], f);
var I = Object.defineProperty, D = Object.getOwnPropertyDescriptor, l = (e, t, a, i) => {
  for (var r = i > 1 ? void 0 : i ? D(t, a) : t, o = e.length - 1, s; o >= 0; o--)
    (s = e[o]) && (r = (i ? s(t, a, r) : s(r)) || r);
  return i && r && I(t, a, r), r;
};
let n = class extends g {
  constructor() {
    super(...arguments), this.$htmlUpdateUtility = new O(this);
  }
  connectedCallback() {
    super.connectedCallback(), this.handleVariantPickerChange = this.handleVariantPickerChange.bind(this), this.addEventListener(
      h,
      this.handleVariantPickerChange
    ), this.$htmlUpdateUtility.addPostProcessCallback(() => {
      var e, t;
      (t = (e = window == null ? void 0 : window.Shopify) == null ? void 0 : e.PaymentButton) == null || t.init();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(
      h,
      this.handleVariantPickerChange
    );
  }
  updateURL(e, t) {
    this.shouldUpdateUrl && window.history.replaceState(
      {},
      "",
      `${e}${t ? `?variant=${t}` : ""}`
    );
  }
  handleVariantPickerChange(e) {
    const t = e.detail.productUrl, a = e.detail.variantId;
    !a || a.trim() === "" || (this.updateURL(t ?? "", a), t && t !== "" && t !== this.productUrl && (this.productUrl = t), this.$htmlUpdateUtility.fetchAndReplaceSectionId({
      renderRoot: this,
      sectionId: this.sectionId,
      baseUrl: t || this.productUrl,
      params: {
        variant: a,
        ...this.view ? { view: this.view } : {}
      },
      withCache: !0
    }).catch((i) => {
      if (i instanceof Error)
        throw i;
      console.warn(i);
    }));
  }
};
l([
  p({ type: String, attribute: "section-id" })
], n.prototype, "sectionId", 2);
l([
  p({ type: String, attribute: "product-url" })
], n.prototype, "productUrl", 2);
l([
  p({ type: String, attribute: "view" })
], n.prototype, "view", 2);
l([
  p({
    type: String,
    attribute: "update-url",
    converter: (e) => e === "true"
  })
], n.prototype, "shouldUpdateUrl", 2);
n = l([
  d("main-product")
], n);
export {
  n as MainProduct
};
